import { createContext } from "react";

export const TokenGlobalContext = createContext({
  status: "idle",
  tokenProd: null,
  TokenIn: () => Promise.resolve(),
  TokenOut: () => Promise.resolve(),
});
